<template>
  <strong class='text-center'>{{ header }}</strong>
</template>

<script>
export default {
  props: [ 'header' ]
}

</script>